import _ from 'lodash'
import type {Experiment, RunningExperiments} from '@wix/document-services-types'

const isTb = process.env.VIEWER_NAME === 'tb'
const runningExperiments: RunningExperiments = {
    dm_stretchRichText: 'true',
    dm_failSplitQueries: 'new',
    dm_throwOnSoqFailure: 'new',
    dm_failCsaveInitConflict: 'new',
    dm_useWhitelistRemovalForCsave: 'new',
    dm_repeatersFromViewer: 'old', //should turn on when we are ready to open in prod
    dm_disableValidationWhitelist: 'new',
    dm_enableMLSlug: 'true',
    dm_nsTypesFailInvalidDesign: 'old', //will turn on by default once we resolve all currently failing tests
    dm_repeaterDontAddRepeatedRefCompData: 'new',
    dm_mobileAlgoValidationNoConduct: 'true',
    dm_useResourceLoaderForInit: 'true',
    dm_fixTextLinksAfterRefAddToContainer: 'new',
    'specs.UseTBAsMainRScript': isTb ? 'new' : 'old',
    'specs.UseTbInPreview': isTb ? 'new' : 'old',
    dm_fixerVersioningDataCollection: 'new',
    dm_failDalStrictSchemaValidation: 'true',
    dm_noWhitelistDalStrictSchemaValidation: 'false', // will be turned on only after cleanup of whitelist
    dm_missingSkinValidator: 'true',
    dm_forceConfigName: 'true',
    dm_blocksNewDevCenterApiComponents: 'true',
    dm_reportRemoteStructureSet: 'true',
    dm_deleteRemoveByParent: 'true',
    dm_validateStylableStyles: 'true',
    dm_validateMigratedStylableStyles: 'true',
    dm_useViewerIsShowOnFixedPosition: 'true',
    dm_internalRefGarbageCollector: 'true',
    dm_sendPresetInfoInBlocksBuild: 'true',
    dm_failOnExceedsMaxActionsPerTransaction: 'true',
    dm_recalculateBlocksOnGroupingAndUngrouping: 'true',
    dm_fixTextScaleInMobileAlgo: 'true',
    dm_platformWorkerFedopsLoggerDefaultsOverride: 'true',
    dm_returnAllAppDataInAddApps: 'true',
    dm_oldHoverBoxDeprecationFixer: 'true',
    dm_rejectDalOnBuildingPayloadForCsaveError: 'true',
    dm_fixSystemStyleAsRefArray: 'true',
    dm_publishPipelineRcSite: 'true',
    dm_allowAddingStripForNonFullWidthPopup: 'true',
    dm_moveMaxChildrenNumberMetadataToExt: 'true',
    dm_moveCompSanitationToExt: 'true',
    dm_disableHideForLastInstalledMainWidget: 'true',
    dm_moveCompValidationToExt: 'true',
    dm_builderDataInAppDescriptor: 'false', //will turn on only for builder
    dm_shouldValidateComponentLayoutMobileAlgo: 'true',
    dm_moveComponentLayoutToExt: 'new',
    dm_waitForPendingCsaveIfNothingToSaveOnSaveAndWait: 'new',
    dm_moveBehaviorsDeserializerToExt: 'new',
    dm_moveBeforeAddComponentHook: 'new',
    dm_reportReferencedDataNodesGC: 'true',
    dm_useExtensionUpdateDisplayedOnlyComponentsDefs: 'new',
    dm_moveCollectAncestorsVariablesIdsToExt: 'new',
    dm_moveVariantUtilsToExt: 'new',
    dm_useExtensionUpdateVariantsInStructure: 'new',
    dm_createWidgetSeparator: 'true',
    dm_deleteDesktopOnlyComponents: 'true',
    dm_runAndWaitForApprovalOnSaveDisabled: 'true',
    dm_serializationHooksInDataModelExtension: 'true',
    dm_react18: 'true',
    dm_moveValidationBaseline: 'true',
    dm_allowReferencingOutOfScopeMasterPageVariables: 'true',
    dm_csaveCreateRevision: 'new',
    dm_doNotCreateGetterForClassnames: 'true',
    dm_addComponentWithSlotOverrides: 'true',
    dm_variantRefOwner: 'true',
    dm_variantRefOwnerFixer: 'true',
    dm_loadRemoteWidgetMetadataFromExt: 'true',
    dm_serializeInternalRefs: 'new',
    dm_cloudSiteExtensionMigrationDev: 'new',
    dm_serializeInnerElements: 'true',
    dm_addSiteWidgetSlotExtensions: 'true',
    dm_fragmentsLoadOnInit: 'true',
    dm_moveCsaveToNewProto: 'true',
    dm_fragments: 'true',
    dm_fragmentsApps: 'true',
    dm_fragmentsGetApps: 'true',
    dm_odeditorSupportOOiInstallation: 'true',
    dm_autoRtlDomReorderClassic: 'true',
    dm_observables: 'true',
    dm_fragmentsEditorFeatures: 'true',
    dm_fixHiddenCompNotRemovedOnMobileAlgo: 'true',
    dm_fixSinglePageLayoutMetadata: 'true',
    dm_enforceStrictValidationEverywhere: 'true',
    dm_shouldRunEditorThreeMobileAlgo: 'true'
}

export const getDefaultExperiments = () => _.cloneDeep(runningExperiments)

export const isExperimentOn = (value: string) => !!(value && value !== 'old' && value !== 'false')

export const createTestExperimentInstance = (experimentOverrides?: RunningExperiments): Experiment => {
    const experiments = _.merge({}, runningExperiments, experimentOverrides)
    return {
        getRunningExperiments: () => experiments,
        getValue: (name: string) => experiments[name],
        isOpen: (name: string) => {
            const value = experiments[name]
            return isExperimentOn(value)
            // return !!(value && value !== 'old' && value !== 'false')
        },
        isMultiValueExperimentOpen: (name: string) => !!experiments[name]
    }
}
